import styles from './styles.module.scss';

const Spinner = () => (
    <div className={styles.spinner}>
        <div className={styles.dot}></div>
    </div>
);

export default Spinner;
